import Auth from './modules/auth.js'
import User from './modules/user.js'
import Project from './modules/project.js'
import Test from './modules/test.js'
import Stat from './modules/stat.js'

export default [
    ...Auth,
    ...User,
    ...Project,
    ...Test,
    ...Stat,

    // otherwise redirect to home
    { path: '*', redirect: '/' },
]
